import { render, staticRenderFns } from "./all-partner.vue?vue&type=template&id=0f878eef&scoped=true&"
import script from "./all-partner.vue?vue&type=script&lang=js&"
export * from "./all-partner.vue?vue&type=script&lang=js&"
import style0 from "./all-partner.vue?vue&type=style&index=0&id=0f878eef&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f878eef",
  null
  
)

export default component.exports